
import React from 'react';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-user-star-line',
      title: 'Personal Brand Management',
      description: 'Build and enhance your professional identity in the sports industry',
    },
    {
      icon: 'ri-shake-hands-line',
      title: 'Sponsorship Relationship Management',
      description: 'Develop and maintain valuable partnerships for sustainable growth',
    },
    {
      icon: 'ri-team-line',
      title: 'Recruitment',
      description: 'Find the right talent to strengthen your sports organisation',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Skill & Talent Management',
      description: 'Identify, develop and retain top performers in your team',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Performance Management',
      description: 'Drive excellence through structured performance systems',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Training & Development',
      description: 'Upskill your people with targeted learning programmes',
    },
    {
      icon: 'ri-user-voice-line',
      title: 'Coaching & Mentoring',
      description: 'Unlock potential through personalised guidance and support',
    },
    {
      icon: 'ri-organization-chart',
      title: 'Organisational Development',
      description: 'Transform your structure and culture for lasting success',
    },
  ];

  return (
    <section className="bg-[#F8F9FA] py-24">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-6">
          <div>
            <p className="text-[#0066FF] uppercase text-sm font-semibold tracking-wide mb-3">
              What We Do
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628]">
              Services built for sport
            </h2>
          </div>
          <p className="text-gray-600 text-lg max-w-md">
            Comprehensive HR solutions designed specifically for the unique needs of sports
            organisations and professionals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#E6F2FF] rounded-full mb-6 group-hover:bg-[#0066FF] transition-colors">
                <i
                  className={`${service.icon} text-3xl text-[#0066FF] group-hover:text-white transition-colors`}
                ></i>
              </div>
              <h3 className="text-xl font-bold text-[#0A1628] mb-3">{service.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
